/**
 * Показывать ли окно «рекомендуемый режим изменился» (task.txt, батч E, п.1).
 *
 * Правило приложения: окно про рекомендуемый режим long/short видит только юзер
 * с ОФОРМЛЕННОЙ ПОДПИСКОЙ (демо или реальный счёт). Владелец 2026-09-27: после
 * создания пробного бота (2 бесплатные сделки) этот параметр новичку не нужен —
 * окно забирает внимание и отвлекает от главного, пока юзер ещё ничего не купил.
 *
 * Было: условие жило прямо в App.jsx и смотрело только на метку режима. У нового
 * юзера `seenModeNoticeAt` = 0, а режим в админке уже задан → окно всплывало
 * СРАЗУ при первом входе, ещё до всякой подписки.
 *
 * Стало: то же условие плюс `hasSubscription`. Метку `seenModeNoticeAt` окно не
 * трогает, пока не показано, поэтому после оформления подписки оно появится само
 * — ровно «после того, как юзер оформит подписку», как просил владелец.
 *
 * Чистая функция без побочных эффектов и без обращений к стору: её же гоняет
 * харнесс проверок (таблица истинности по всем входам).
 */
export function shouldShowModeNotice({
  profileOk,
  loading,
  isAdmin,
  modeChangedAt,
  seenModeNoticeAt,
  dismissedFor,
  hasSubscription,
}) {
  // Профиль ещё не пришёл / скелетон загрузки / админу окно не нужно вовсе
  // (он и есть тот, кто меняет режим).
  if (!profileOk || loading || isAdmin) return false
  // Новичок без подписки (в т.ч. с пробным ботом) — окно откладывается.
  if (!hasSubscription) return false
  const changed = Number(modeChangedAt) || 0
  if (changed <= 0) return false          // режим админ ещё ни разу не менял
  const seen = Number(seenModeNoticeAt) || 0
  if (seen >= changed) return false        // юзер уже подтвердил эту смену
  return changed !== dismissedFor          // и окно не закрыто в текущей сессии
}
